export default "__VITE_ASSET__416006cd__"